var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProspect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 159 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_901_2614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.572 73.9459L130.037 61.1792L155.572 48.4126C160.14 46.1287 160.143 39.5882 155.572 37.3012L82.2784 0.656552C80.5296 -0.217793 78.4727 -0.217793 76.7208 0.656552L3.42718 37.3012C-1.14084 39.5851 -1.14395 46.1256 3.42718 48.4126L28.962 61.1792L3.42718 73.9459C-1.14084 76.2298 -1.14395 82.7702 3.42718 85.0572L28.962 97.8239L3.42718 110.591C-1.14084 112.874 -1.14395 119.415 3.42718 121.702L76.7208 158.347C78.4665 159.218 80.5234 159.221 82.2784 158.347L155.572 121.702C160.14 119.418 160.143 112.878 155.572 110.591L130.037 97.8239L155.572 85.0572C160.14 82.7734 160.143 76.2329 155.572 73.9459ZM79.4996 13.1556L138.903 42.8553L79.4996 72.555L20.0967 42.8553L79.4996 13.1556ZM138.903 116.145L79.4996 145.844L20.0967 116.145L42.8528 104.766L76.7208 121.699C78.4665 122.57 80.5234 122.573 82.2784 121.699L116.146 104.766L138.903 116.145ZM79.4996 109.2L20.0967 79.5L42.8528 68.1211L76.7208 85.0541C78.4665 85.9254 80.5234 85.9285 82.2784 85.0541L116.146 68.1211L138.903 79.5L79.4996 109.2Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_901_2614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 159,
    height: 159,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProspect);
export default __webpack_public_path__ + "static/media/prospect.cbc52e0d.svg";
export { ForwardRef as ReactComponent };